/* PDP gallery: always open on the featured (first) image.

   iOS Safari restores the horizontal media slider to a previously-viewed image on
   bfcache restore / return navigation, so a PDP can open mid-gallery with a visible
   "shuffle" instead of on image 1. Force it back to the first slide once the browser
   has finished its own scroll restoration.

   Guarded to a no-op unless the slider is actually off the first image, so a normal
   fresh load (already at 0) and Chromium (which doesn't restore) are untouched. The
   theme never deep-links the gallery to a non-first media (onVariantChanged does not
   scroll it), so forcing the first slide on show can't fight an intended position.

   ponytail: iOS-Safari-specific and not reproducible in Chromium — verify on device. */
(function () {
  function reset() {
    document.querySelectorAll('media-gallery slider-element').forEach(function (slider) {
      if (Math.abs(slider.scrollLeft) < 2) return;
      try {
        slider.scrollTo({ left: 0, behavior: 'instant' });
      } catch (e) {
        slider.scrollLeft = 0;
      }
    });
  }

  // pageshow fires on a normal load and on bfcache restore; reset after Safari has
  // applied its own scroll restoration (next frame, plus a short fallback).
  window.addEventListener('pageshow', function () {
    requestAnimationFrame(reset);
    setTimeout(reset, 120);
  });
})();
